package one.healthium.rateus.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import loco.RATE_US_ALERT_MESSAGE
import loco.RATE_US_ALERT_NEGATIVE_BUTTON
import loco.RATE_US_ALERT_POSITIVE_BUTTON
import loco.RATE_US_ALERT_TITLE_FORMAT
import loco.RATE_US_IMPROVE_ALERT_NEGATIVE_BUTTON
import loco.RATE_US_IMPROVE_ALERT_POSITIVE_BUTTON
import loco.RATE_US_IMPROVE_ALERT_TITLE
import one.healthium.base.launcher.LocalPlatformLauncher
import one.healthium.base.preferences.AppPreferences
import one.healthium.base.utils.BundleUtils
import one.healthium.rateus.data.ComposeFeedbackEmail
import one.healthium.rateus.data.RateApp
import one.healthium.ui.compose.components.AlertButtonType
import one.healthium.ui.compose.components.AppAlertDialog
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.koinInject

@Composable
fun RateUsDialog(
    onDismissRequest: () -> Unit = {}
) {
    val appPreferences: AppPreferences = koinInject<AppPreferences>()
    val platformLauncher = LocalPlatformLauncher.current

    var showPopup by remember { mutableStateOf(false) }
    var rateApp by remember { mutableStateOf(false) }
    var showBasePopup by remember { mutableStateOf(true) }

    if (showBasePopup) {
        AppAlertDialog(
            positiveButton = stringResource(loco.Res.string.RATE_US_ALERT_POSITIVE_BUTTON),
            negativeButton = stringResource(loco.Res.string.RATE_US_ALERT_NEGATIVE_BUTTON),
            onPositiveClick = { rateApp = true },
            onNegativeClick = { showPopup = true },
            negativeButtonType = AlertButtonType.DEFAULT,
            title = stringResource(loco.Res.string.RATE_US_ALERT_TITLE_FORMAT, BundleUtils.getAppName(platformLauncher)),
            text = stringResource(loco.Res.string.RATE_US_ALERT_MESSAGE),
            onDismissRequest = { }
        )
    }

    if (showPopup) {
        showBasePopup = false
        ShowImprovePopup(onDismissRequest = {
            onDismissRequest()
        })

    }
    if (rateApp) {
        showBasePopup = false
        appPreferences.didRateApp = true
        RateApp()
        onDismissRequest()

    }
}

@Composable
private fun ShowImprovePopup(onDismissRequest: () -> Unit = {}) {
    var composeEmail by remember { mutableStateOf(false) }
    AppAlertDialog(
        positiveButton = stringResource(loco.Res.string.RATE_US_IMPROVE_ALERT_POSITIVE_BUTTON),
        negativeButton = stringResource(loco.Res.string.RATE_US_IMPROVE_ALERT_NEGATIVE_BUTTON),
        onPositiveClick = {
            composeEmail = true
        },
        onNegativeClick = onDismissRequest,
        negativeButtonType = AlertButtonType.DEFAULT,
        title = stringResource(loco.Res.string.RATE_US_IMPROVE_ALERT_TITLE),
        onDismissRequest = {}
    )

    if (composeEmail) {
        ComposeFeedbackEmail()
        onDismissRequest()
    }
}
